import React, { useEffect, useCallback, useState} from 'react';
import {connect} from 'react-redux';

const Tags = ({setTags, tags, placeholder="Type tags"}) => { 
    let [value, setValue] = useState('');
    const deleteTag = useCallback(t => {
        setTags(
            tags.filter(x => x !== t));
    }, [tags, setTags]);

    const onKeyDown = useCallback((e) => {
        if (e.key === 'Enter') {
            setTags([... tags, value]);
            setValue('');
        }
    }, [setTags, tags, value]);
 
    return (
        <div className="tags">
          {tags.map(tag => <div onClick={() => deleteTag(tag)} className="tag-option">{tag}</div>)}
          <input placeholder={placeholder} className="tag-sample-input" onKeyDown={onKeyDown} value={value} type="text" onChange={e => setValue(e.target.value)}/>
        </div>);
};

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Tags);
